import {
  ADD_BALANCE_DECLINED,
  ADD_BALANCE_FAILED,
  ADD_BALANCE_PENDING,
  RESET_ADD_BALANCE,
  ADD_BALANCE_SUCCESS,
  ADD_BALANCE_OPERATION_NOT_PERMITTED,
  ADD_BALANCE_TRANSACTION_LIMIT_OVER,
  ADD_BALANCE_NOT_SUFFICIENT_LIMIT,
  ADD_BALANCE_TRANSACTION_LIMIT_EXCEEDED,
  LOADING_ADD_BALANCE
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  pending: false,
  success: false,
  declined: false,
  operationNotPermitted: false,
  transactionLimitOver: false,
  notSufficientLimit: false,
  transactionLimitExceeded: false,
  amount: 0,
  networkError: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_ADD_BALANCE:
      return {
        ...state,
        isLoading: true,
        success: false,
        pending: false,
        failed: true,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };
    case ADD_BALANCE_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        pending: false,
        failed: true,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };
    case ADD_BALANCE_PENDING:
      return {
        ...state,
        isLoading: false,
        success: false,
        pending: true,
        failed: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };
    case ADD_BALANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };

    case ADD_BALANCE_DECLINED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        declined: true,
        pending: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };

    case ADD_BALANCE_OPERATION_NOT_PERMITTED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: true,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };

    case ADD_BALANCE_TRANSACTION_LIMIT_OVER:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: true,
        notSufficientLimit: false,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };

    case ADD_BALANCE_NOT_SUFFICIENT_LIMIT:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: true,
        transactionLimitExceeded: false,
        amount: action.payload,
        networkError: ""
      };

    case ADD_BALANCE_TRANSACTION_LIMIT_EXCEEDED:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: false,
        pending: false,
        declined: false,
        operationNotPermitted: false,
        transactionLimitOver: false,
        notSufficientLimit: false,
        transactionLimitExceeded: true,
        amount: action.payload,
        networkError: ""
      };

    case RESET_ADD_BALANCE:
      return (state = initialState);

    default:
      return state;
  }
};
